import { ReactNode, RefObject } from "react";

import {
  Box,
  ComponentWithAs,
  Heading,
  IconProps,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";

type Props = {
  body: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  icon: ComponentWithAs<"svg", IconProps>;
  initialFocusRef?: RefObject<HTMLElement>;
} & UseDisclosureReturn;

export default function IconModal({ body, header, footer, icon: IconComponent, ...modalProps }: Props) {
  return (
    <Modal {...modalProps}>
      <ModalOverlay />
      <ModalContent alignItems="center" boxShadow="lg" justifyContent="space-between" py={10}>
        <ModalHeader>
          <VStack spacing={6}>
            <Box
              alignItems="center"
              backgroundColor="background.darker"
              borderRadius="50%"
              color="text.primary"
              display="flex"
              fontSize="fs.700"
              height={20}
              justifyContent="center"
              width={20}
            >
              <IconComponent />
            </Box>
            <Heading size="md">{header}</Heading>
          </VStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>{body}</ModalBody>
        <ModalFooter mt={4}>{footer}</ModalFooter>
      </ModalContent>
    </Modal>
  );
}
